import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {RouterModule,Routes} from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { GlobalService } from './global.service';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';
import { AuthInterceptor } from './app.interceptor';
import { UnosIzmjenaPravnoLice } from './unos-izmjena-plice/unos-izmjena-plice.component';
import { UnosIzmjenaFizLice } from './unos-izmjena-flice/unos-izmjena-flice.component';
import { PregledAutomobilaComponent } from './pregled-automobila/pregled-automobila.component';
import { UnosIzmjenaVoziloComponent } from './unos-izmjena-vozilo/unos-izmjena-vozilo.component';
import { UnosIzmjenaSifarnikComponent } from './unos-izmjena-sifrarnik/unos-izmjena-sifrarnik.component';
import { PregledPregledaComponent } from './pregled-pregleda/pregled-pregleda.component';
import { UnosIzmjenaPregledComponent } from './unos-izmjena-pregled/unos-izmjena-pregled.component';
import { PregledVlasnikaComponent } from './pregled-vlasnika/pregled-vlasnika.component';
import { PretragaAutomobilaComponent } from './pretraga-automobila/pretraga-automobila.component';
import { PregledSifrarnikaComponent } from './pregled-sifrarnika/pregled-sifrarnika.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AdminHomeComponent } from './admin-home/admin-home.component';
import { AdminStatistikaComponent } from './admin-statistika/admin-statistika.component';
import { UnosIzmjenaBrojMjestaComponent } from './unos-izmjena-broj-mjesta/unos-izmjena-broj-mjesta.component';
import { FilterAutoPipe } from './filter.pipe';
import { FilterSifrarnikPipe } from './filter.pipe';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    FooterComponent,
    LoaderComponent,
    AdminHomeComponent,
    AdminStatistikaComponent,
    UnosIzmjenaBrojMjestaComponent,
    UnosIzmjenaPravnoLice,
    UnosIzmjenaFizLice,
    PregledAutomobilaComponent, 
    UnosIzmjenaVoziloComponent, 
    UnosIzmjenaSifarnikComponent, 
    PregledPregledaComponent, 
    UnosIzmjenaPregledComponent, 
    PregledVlasnikaComponent, 
    FilterAutoPipe,
    FilterSifrarnikPipe,
    PretragaAutomobilaComponent, 
    PregledSifrarnikaComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule, 
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule],
  providers: [{provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor,multi: true }, GlobalService],
  bootstrap: [AppComponent]
})
export class AppModule { }
